import React from "react";
import { cn } from "@/lib/utils";

interface SectionHeaderProps {
  title: string;
  className?: string;
  onClick?: () => void;
  hasErrors?: boolean;
  errorMessage?: string;
  children?: React.ReactNode;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  className,
  onClick,
  hasErrors = false,
  errorMessage,
  children,
}) => {
  const Tag: React.ElementType = onClick ? "button" : "div";

  return (
    <Tag
      {...(onClick ? { type: "button" } : {})}
      onClick={onClick}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e: React.KeyboardEvent) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
      className={cn(
        "SectionHeader flex h-[30px] w-full items-center gap-1 self-stretch rounded-md bg-edge-input px-2",
        onClick && "cursor-pointer",
        hasErrors && "border-2 border-red-500",
        className
      )}
    >
      <span className="font-inter text-base font-medium text-ink-secondary">
        {title}
      </span>
      {children}
      {hasErrors && errorMessage && (
        <span className="ml-auto text-xs text-red-600">{errorMessage}</span>
      )}
    </Tag>
  );
};

export default SectionHeader;
